import React from "react";
import { Clock, RefreshCw, LogOut } from "lucide-react";

export default function SessionTimeoutWarningModal({
  isOpen,
  remainingSeconds,
  onStayLoggedIn,
  onLogout
}) {
  if (!isOpen) return null;

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeFormatted = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

  return (
    <div className="modal-overlay" style={{ zIndex: 99999, backgroundColor: "rgba(0, 0, 0, 0.85)" }}>
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()} 
        style={{ 
          maxWidth: "460px", 
          textAlign: "center", 
          padding: "2rem",
          border: "1px solid var(--warning, #f59e0b)",
          boxShadow: "0 10px 25px -5px rgba(245, 158, 11, 0.3)"
        }}
      >
        <div style={{
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          backgroundColor: "rgba(245, 158, 11, 0.15)",
          color: "var(--warning, #f59e0b)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 1.25rem auto"
        }}>
          <Clock size={28} />
        </div>

        <h3 style={{ margin: "0 0 0.5rem 0", color: "var(--text-primary)", fontSize: "1.25rem" }}>
          Session Inactivity Warning
        </h3>

        <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem", lineHeight: 1.5, margin: "0 0 1.5rem 0" }}>
          You have been inactive. For your security and compliance safeguarding, your session will expire automatically in:
        </p>

        <div style={{
          fontSize: "2.25rem",
          fontWeight: 700,
          fontFamily: "var(--font-heading)",
          color: "var(--warning, #f59e0b)",
          marginBottom: "1.75rem",
          letterSpacing: "2px"
        }}>
          {timeFormatted}
        </div>

        <div style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onLogout}
            style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", padding: "0.6rem 1.2rem" }}
          >
            <LogOut size={16} />
            Log Out Now
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onStayLoggedIn}
            style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", padding: "0.6rem 1.25rem" }}
          >
            <RefreshCw size={16} />
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
}
